import { useEffect } from "react";

/**
 * Liga o manifest do portal enquanto o portal está montado.
 *
 * O `index.html` é o mesmo para o BI e para o portal. Pôr o manifest nele faria o
 * navegador oferecer "instalar" nas telas gerenciais, com `start_url` do portal —
 * confuso. Injetado aqui, só o portal é instalável; ao sair, tudo é removido.
 */
const TAGS: Array<{ tag: "link" | "meta"; attrs: Record<string, string> }> = [
  { tag: "link", attrs: { rel: "manifest", href: "/app-frota.webmanifest" } },
  { tag: "meta", attrs: { name: "theme-color", content: "#12351F" } },
  { tag: "link", attrs: { rel: "apple-touch-icon", href: "/icons/app-frota-apple-180.png" } },
  { tag: "meta", attrs: { name: "apple-mobile-web-app-capable", content: "yes" } },
  { tag: "meta", attrs: { name: "mobile-web-app-capable", content: "yes" } },
  { tag: "meta", attrs: { name: "apple-mobile-web-app-title", content: "SIAG Frota" } },
  { tag: "meta", attrs: { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" } },
];

export function usePortalManifest() {
  useEffect(() => {
    const criados = TAGS.map(({ tag, attrs }) => {
      const el = document.createElement(tag);
      for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
      el.setAttribute("data-portal", "frota");
      document.head.appendChild(el);
      return el;
    });
    const tituloAnterior = document.title;
    document.title = "SIAG Frota · Portal Operacional";
    return () => {
      criados.forEach((el) => el.remove());
      document.title = tituloAnterior;
    };
  }, []);
}
